import {BaseAppModel} from "./AppModel";

export default class Company extends BaseAppModel<Company> {
    name!: string
    fullname!: string
    key!: string
    natureKey!: string
}
